module.exports = __webpack_public_path__ + "static/gallery-desktop-116134b331bbbed6781e58bfe9c86d91.jpg";